import { render, staticRenderFns } from "./message-lab-request.vue?vue&type=template&id=905456fc"
import script from "./message-lab-request.vue?vue&type=script&lang=js"
export * from "./message-lab-request.vue?vue&type=script&lang=js"
import style0 from "./message-lab-request.vue?vue&type=style&index=0&id=905456fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports